import { render, staticRenderFns } from "./AdvertisingManagement.vue?vue&type=template&id=58e8fa69&scoped=true&"
import script from "./AdvertisingManagement.vue?vue&type=script&lang=js&"
export * from "./AdvertisingManagement.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingManagement.vue?vue&type=style&index=0&id=58e8fa69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e8fa69",
  null
  
)

export default component.exports